// CelebrantsGrid.jsx
import React from "react";
import CelebrantCard from "../celebrant/celebrantcard";

const CelebrantsGrid = ({ title, celebrants }) => {
  return (
    <div className="p-6 max-w-8xl mx-auto bg-white">
      <h2 className="text-lg font-bold mb-4">🎉 {title}</h2>
      <div className="flex flex-wrap gap-4">
        {celebrants.map((celebrant, index) => (
          <CelebrantCard
            key={index}
            name={celebrant.name}
            role={celebrant.role}
            date={celebrant.date}
            isToday={celebrant.isToday}
            imageUrl={celebrant.imageUrl}
          />
        ))}
      </div>
    </div>
  );
};

export default CelebrantsGrid;
